import {
	EnhancedCampaign,
	EnhancedCampaignOld,
	EnhancedCategory,
	EnhancedGame,
	GameProvider
} from '~/components/casino-shared/types';
import { ExploreResponse } from '../types';
import {
	EXPLORE_CASINO_PROCESS,
	FETCH_CASINO_GAMES_START,
	HYDRATE_CASINO_GAMES,
	INVALIDATE_CASINO_DATA,
	PREVIOUS_LOCATION
} from './action-names';

export const EXPLORE_CASINO_SUCCESS = 'casino_success';
export const EXPLORE_CASINO_LOADING = 'casino_loading';
export const EXPLORE_CASINO_ERROR = 'casino_error';

export type State = {
	initialized?: boolean;
	hydrated: boolean;
	wasAuthenticated: boolean;
	games: Record<string, EnhancedGame>;
	gameNamesByIdx: string[];
	gameCodesByIdx: string[];
	gameCodesByProviderCode: Record<string, string[]>;
	gameCodesBySubProviderCode: Record<string, string[]>;
	loading: boolean;
	previousLocation?: {
		pathname: string;
		search: string;
	};
	campaigns: EnhancedCampaign[] | EnhancedCampaignOld[];
	exploreCategories: EnhancedCategory[];
	exploreCasinoStatus:
		| typeof EXPLORE_CASINO_SUCCESS
		| typeof EXPLORE_CASINO_LOADING
		| typeof EXPLORE_CASINO_ERROR
		| null;
	providers: Record<string, GameProvider>;
	subProviders: Record<string, GameProvider>;
};

export type Actions =
	| { type: typeof FETCH_CASINO_GAMES_START }
	| {
			type: typeof HYDRATE_CASINO_GAMES;
			payload: {
				hydrated: true;
				wasAuthenticated: boolean;
				response: ExploreResponse;
				imageDescriptors: string[];
				imageFormats: string[];
				campaignBackgroundImageDescriptors: string[] | null | undefined;
				campaignForegroundImageDescriptors: string[] | null | undefined;
				enableBannerService: boolean;
				license: string;
			};
	  }
	| {
			type: typeof PREVIOUS_LOCATION;
			payload: {
				pathname: string;
				search: string;
			};
	  }
	| { type: typeof EXPLORE_CASINO_PROCESS; payload: State['exploreCasinoStatus'] }
	| {
			type: typeof INVALIDATE_CASINO_DATA;
	  };
